class FlipCard{
    constructor(el){
        this.el =el;
        this.flipButtonFront = document.querySelectorAll('.AlliancePartners-partnerCards-cardFront-button');
        this.flipButtonBack = document.querySelectorAll('.AlliancePartners-partnerCards-cardBack-button');

        this.flipButtonFront.forEach(el => {
            el.addEventListener('click', function () {
                let cardItem = el.closest('.AlliancePartners-partnerCards-card');
                    cardItem.classList.toggle('turn');
            });
          });

          this.flipButtonBack.forEach(el => {
            el.addEventListener('click', function () {
                let cardItem = el.closest('.AlliancePartners-partnerCards-card');
                    cardItem.classList.toggle('turn');
            });
          });
    } //end constructor
} // end class

const init = () => {

    let flipCardClass = document.querySelector(".AlliancePartners-partnerCards"); // This class must be added to the gravity form in the WP Admin

    if (flipCardClass) {
      new FlipCard(flipCardClass);
    }
  };

   // Init on initial page load
init();
